import React, { FC } from 'react';
import { useFormikContext } from 'formik';

import { FormInput } from 'Shared/components';
import { SelectOption } from 'QuoteApp/services/endpoints/GetConfig';

import { PriceCustomizerFormValues } from '../domain';
import styles from './styles.module.css';

type DayOfMonthSelectorType = {
  isLoading?: boolean;
  options: Array<SelectOption<string>>;
  onChange?: (value: string) => void;
};

export const DayOfMonthSelector: FC<DayOfMonthSelectorType> = ({
  isLoading,
  options,
  onChange,
}) => {
  const { handleBlur, setFieldValue, values } = useFormikContext<
    PriceCustomizerFormValues
  >();

  const handleChange = (selectedValue: string) => {
    setFieldValue('monthly', selectedValue);

    if (onChange) {
      onChange(selectedValue);
    }
  };

  const transformOptions = (
    options: Array<SelectOption<string>>
  ): { [value: string]: string } => {
    return options.reduce((acc, option) => {
      acc[option.value] = option.label;
      return acc;
    }, {} as { [value: string]: string });
  };

  return (
    <FormInput
      data-testid="payflex-monthly"
      variant="selectAutocomplete"
      name="monthly"
      label="Payment date"
      value={values.monthly}
      disabled={isLoading}
      className={styles.dayOfMonthSelector}
      options={transformOptions(options)}
      onChange={handleChange}
      onBlur={handleBlur}
    />
  );
};
